<template>
  <!-- -->
  <div class="solution-customer">
    <list-page>
      <search-condition @search="resetSearch" :show-border="false" :show-shadow="false">
        <template #default>
          <erp-customer-select v-model="searchInfo.customerId" placeholder="请选择客户">
            <template #prefix>客户名称</template>
          </erp-customer-select>
          <el-select v-model="searchInfo.dataId" filterable placeholder="请选择推荐方案" clearable>
            <template #prefix>推荐方案</template>
            <el-option v-for="item in solutionList" :key="item.id" :label="item.solutionName" :value="item.id"/>
          </el-select>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button type="write" el-type="success">新建</page-button>
        </template>
      </search-condition>
      <list-table :show-shadow="false">
        <yq-table :data="dataList" height="100%" stripe border >
          <yq-table-column  label="客户名称" prop="btypeName" min-width="180rem"/>
          <yq-table-column  label="推荐方案" prop="solutionName" min-width="180rem"/>
          <yq-table-column  label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button @click="toManage(row)">管理</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList" :show-border="false" :show-shadow="false"/>
    </list-page>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition";
import FormPage from "@/components/h5/layout/FormPage";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage";
import TableButton from "@/components/h5/button/TableButton";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import ErpCustomerSelect from "@/components/h5/partner/ErpCustomerSelect.vue";
import qywxXbotSolutionApi from "@/api/dz-ai/qywxXbotSolutionApi";
import {useRoute, useRouter} from "vue-router";
export default {
  name: "",
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  components: {
    YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage, ErpCustomerSelect
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      solutionList: [],
    };
  },
  created() {
    this.resetSearch();
    qywxXbotSolutionApi.queryAll().then(res => {
      this.solutionList = res;
    })
  },
  methods: {
    queryList() {
      qywxXbotSolutionApi.queryListByBtype(this.searchInfo).then(res => {
        this.dataList = res.records;
        this.searchInfo.totalCount = res.total;
      })
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    toManage(data) {
      this.router.push(`/qywx/quotation/solution/detail?id=${data.id}`)
    }
  }
};
</script>

<style lang="scss" scoped>
.solution-customer{
  height: 100%;
}
</style>